import { L as LICENSE_MIN_PRICE, e as LICENSE_MAX_PRICE } from "./private.js";
import { e as error } from "./index2.js";
import range from "lodash/range.js";
process.env.NODE_ENV === "production";
const isDevelopment = process.env.NODE_ENV === "development";
const getPriceRange = () => range(Number(LICENSE_MIN_PRICE), Number(LICENSE_MAX_PRICE) + 1);
const handleRequest = (handler, secure = true) => {
  return async (event) => {
    const { request } = event;
    const secret = request.headers.get("X-Glimmr-Secret-Key") || event.url.searchParams.get("key");
    event.locals.secret = secret;
    if (secure && !secret) {
      error(403, {
        message: "Unauthorized"
      });
    }
    if (secure && secret) {
      const response = await event.fetch(`/api/users/${secret}`);
      if (!response.ok) {
        error(403, {
          message: "Unauthorized"
        });
      }
      event.locals.user = await response.json();
    }
    return handler(event);
  };
};
export {
  getPriceRange as g,
  handleRequest as h,
  isDevelopment as i
};
